import * as React from 'react';
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import store from 'src/storeWire';

const ObsoleteOutOfStockPopup = (props) => {

    const { SetStatus } = props;
    const { ERPMFRPartNumber, ObsoleteFlag, quantity } = props.data;

    return (
        <>
            <div className="avnet-modal modal-375">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3"
                        onClick={() => {
                            SetStatus(false)
                            store.dispatch(SET_ADD_CART_DATA(false))
                        }}
                    >×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">Edit Quantity</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />
                        <div className="mt-3 mb-5">
                            <p className='m-b-15'><b>Part Number: </b>
                                <b>{ERPMFRPartNumber}</b></p>
                            <p className='m-b-15'>We only
                                have <b>{quantity} of {ERPMFRPartNumber}</b> in
                                stock</p>
                            <p>The product status for this part of {`${ObsoleteFlag ? "“Obsolete”" : "“End of Life”"}`} and will no longer be available once
                                the available quantity has been depleted. Please adjust the requested quantity
                                accordingly.</p>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm"
                                onClick={() => {
                                    SetStatus(false)
                                    store.dispatch(SET_ADD_CART_DATA(false))
                                }}
                            >
                                Edit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ObsoleteOutOfStockPopup;